import * as z from "zod";
export const TableDiff = z.object({
    type: z.literal("table_diff"),
    value: z.object({
        headers: z.string().array(),
        bodies: z
            .object({
            /** should be the same length as headers */
            actualRow: z.string().array(),
            /** should be the same length as headers */
            expectedRow: z.string().array(),
            isCorrect: z.boolean(),
        })
            .array(),
    }),
});
